<template>
  <v-app>
    <template v-if="$route.meta.requiresAuth && authStore.user">
      <AuthenticatedLayout>
        <router-view></router-view>
      </AuthenticatedLayout>
    </template>
    <template v-else>
      <v-main>
        <router-view></router-view>
      </v-main>
    </template>
    <v-snackbar
      v-model="snackbar"
      location="top"
      :timeout="3000"
      :color="snackbarColor"
    >
      {{ snackbarText }}
    </v-snackbar>
  </v-app>
</template>

<script setup>
import { onMounted, watch, provide, ref } from 'vue'
import AuthenticatedLayout from '@/components/AuthenticatedLayout.vue'
import { useAuthStore } from '@/stores/authStore'
import { getRefreshToken } from '@/utils/tokenStorage'
import { useRoute, useRouter } from 'vue-router'
import { useCajaStore } from '@/stores/cajaStore'
const cajaStore = useCajaStore()

const authStore = useAuthStore()
const $route = useRoute()
const router = useRouter()
const cajaReady = ref(false)

// Provide the cajaReady state to child components
provide('cajaReady', cajaReady)

watch(
  () => authStore.appReady,
  async (newValue) => {
    await cajaStore.getLastCaja()
    cajaReady.value = true
    if (newValue) {
      cajaReady.value = true
      console.log('App está listo después del login')
    }
  }
)

// Función para redirigir a usuarios de solo turnos
const redirectTurnosUser = () => {
  // if (authStore.isTurnosOnly && $route.path !== '/turnos/ver-turnos') {
  //   // console.log('Redirigiendo a usuario de solo turnos desde App.vue')
  //   // // Usar redirección directa para evitar problemas con el router
  //   // window.location.href = '/turnos/ver-turnos'
  //   return true
  // }
  return false
}

// Observar cambios en el usuario y la ruta
watch(
  [() => authStore.user, () => $route.path],
  // ([newUser, newPath]) => {
  //   if (newUser && authStore.isTurnosOnly && newPath !== '/turnos/ver-turnos') {
  //     console.log('Watch detectó cambio - redirigiendo a turnos')
  //     redirectTurnosUser()
  //   }
  // },
  { immediate: true }
)

onMounted(async () => {
  console.log('App mounted', $route.path)
  if ($route.path == '/login') return
  console.log('authStore.isAuthenticated', authStore.user, authStore)

  try {
    if (!getRefreshToken()) {
      router.push('/login')
      return
    }
    console.log('authStore.isTurnosOnly:', authStore.isTurnosOnly)

    // Reset cajaReady state
    cajaReady.value = false

    let needsFetchUser = !authStore.user

    if (needsFetchUser) {
      await authStore.fetchUser()

      // Verificar si es usuario de solo turnos
      if (redirectTurnosUser()) {
        return // Detener la ejecución si se redirigió
      }
    }

    // Always load the caja on page refresh if not turnos only user
    if (!authStore.isTurnosOnly) {
      await cajaStore.getLastCaja()
      cajaReady.value = true
      console.log('Recepción cajaReady:', cajaReady.value)
    }
  } catch (error) {
    console.error('Error refreshing token:', error)
  }
})
</script>
<style>
.v-table {
  font-size: 1em !important;
}
.v-table table thead th {
  font-weight: bold !important;
}
thead {
  background-color: #005dc2;
  color: white;
}
.v-input--readonly .v-field__field {
  background-color: #dfdcdc !important;
  color: black !important;
}
/* 
.v-table .v-toolbar__content {
  max-width: 1120px;
} */
.expanded-detalle {
  background-color: #00b7ff10;
  font-size: 0.9em;
  font-style: italic;
  padding: 3 !important;
}
</style>
